import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const Company = ({
    registrationIdsSelected,
    isActiveFilter
}) => {
    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingItemPanel, setLoadingItemPanel] = useState(null);
    const [recordsItemByUserId, setRecordsItemByUserId] = useState(null);
    const [attributesDetailItemPanel, setAttributesDetailItemPanel] = useState(null);
    const [companyIdSelected, setCompanyIdSelected] = useState([]);

    const readOnlyAttributes = !(inserting || updating);

    const [id, setId] = useState(null);
    const [companyName, setCompanyName] = useState(null);
    const [city, setCity] = useState(null);
    const [state, setState] = useState(null);
    const [address, setAddress] = useState(null);
    const [addressNumber, setAddressNumber] = useState(null);
    const [postalCode, setPostalCode] = useState(null);
    const [province, setProvince] = useState(null);
    const [email, setEmail] = useState(null);
    const [phone, setPhone] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [dtUpdate, setDtUpdate] = useState(null);
    const [username, setUsername] = useState(null);
    const [creationDate, setCreationDate] = useState(null);
    const [userCreation, setUserCreation] = useState(null);
    const [cpfCnpj, setCpfCnpj] = useState(null);

    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "companyName", value: companyName, setter: setCompanyName },
        { name: "cpfCnpj", value: cpfCnpj, setter: setCpfCnpj },
        { name: "city", value: city, setter: setCity },
        { name: "state", value: state, setter: setState },
        { name: "address", value: address, setter: setAddress },
        { name: "addressNumber", value: addressNumber, setter: setAddressNumber },
        { name: "postalCode", value: postalCode, setter: setPostalCode },
        { name: "province", value: province, setter: setProvince },
        { name: "email", value: email, setter: setEmail },
        { name: "phone", value: phone, setter: setPhone },
        {
            name: "isActive",
            value: isActive,
            setter: setIsActive,
            resetValue: 'S',
            checks: [
                {
                    field: 'isActive',
                    condition: 'VALUE_EQUALS',
                    arrayValue: ['S']
                }
            ]
        },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate },
        { name: "username", value: username, setter: setUsername },
        { name: "creationDate", value: creationDate, setter: setCreationDate },
        { name: "userCreation", value: userCreation, setter: setUserCreation }
    ];

    useEffect(() => {
        reloadListItem()
    }, []);

    useEffect(() => {
        reloadListItem()
    }, [registrationIdsSelected, isActiveFilter]);

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setCompanyIdSelected([])
    }, [isActiveFilter]);

    useEffect(() => {
        reloadListItem()
        if (!companyIdSelected || companyIdSelected.length > 1) {
            setCompanyIdSelected([])
        }
    }, [companyIdSelected, updating]);


    useEffect(() => {
        if (companyIdSelected && companyIdSelected.length === 1) {
            fetchDataDetail(companyIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [companyIdSelected]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '83%'
    };

    async function reloadListItem() {
        return;
        const parameters = { isActive: isActiveFilter }
        const items = await ExecuteAxios.api('get', `/company/grid/`, { params: parameters });
        setRecordsItemByUserId(items);
        RemoveIdsNotFound.remove(items, setCompanyIdSelected, companyIdSelected)
    }

    const fetchDataDetail = async (companyIdSelected) => {
        const parameters = { id: companyIdSelected ? companyIdSelected : 0 }
        const item = await ExecuteAxios.api('get', `/company/detail/`, { params: parameters })
        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }

        if (false && !companyIdSelected || companyIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getItemPanelListOrDetail = () => {
        if (!updating && !inserting && false) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setCompanyIdSelected}
                    idsSelected={companyIdSelected}
                    data={recordsItemByUserId}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailItemPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postItem() {
        try {
            setLoadingItemPanel(true);

            const response = await ExecuteAxios.api('post', `/company/`, {
                clientName: companyName,
                cpfCnpj,
                city,
                state,
                address,
                addressNumber,
                postalCode,
                province,
                email,
                phone,
                isActive
            });

            if (response) {
                await reloadListItem();
                setInserting(false);
            }

            return response;
        } finally {
            setLoadingItemPanel(false);
        }
    }

    async function putItem() {
        try {
            setLoadingItemPanel(true);

            const response = await ExecuteAxios.api('put', `/company/`, {
                id,
                clientName: companyName,
                cpfCnpj,
                city,
                state,
                address,
                addressNumber,
                postalCode,
                province,
                email,
                phone,
                isActive
            });

            if (response) {
                await reloadListItem();
                setUpdating(false);
            }

            return response;
        } finally {
            setLoadingItemPanel(false);
        }
    }

    return (
        <LoadingIndicator loaded={!loadingItemPanel}>
            <Panel
                style={itemPanelStyle}
                titlePage={'Empresas'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={true}
                putFunction={putItem}
                enableNewRecord={false}
                canNewRecord={registrationIdsSelected && registrationIdsSelected.length === 1}
                postFunction={postItem}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={companyIdSelected}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailItemPanel}
                attributeList={attributeList}
                onUpdateIdSelected={setCompanyIdSelected}
            >
                {getItemPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}
export default Company;